import React, { useState } from "react";
import LegalbirdIoModal from "../../Modal/LegalbirdIoModal";
import ButtonLoading from "../../Button/ButtonLoading";
import { dateFieldDefault, relatedFieldDefault } from "../../../services/validationRules";
import { formValue } from "../../../services/formServiceFunctions";
import _ from "lodash";
import { Grid } from "@mui/material";
import FormElement, { FormElementPropsWithoutProduct } from "../../Case/CaseForm/FormElement";
import useForm from "../../../hooks/useForm";
import advoAssistPostponeModalStyle from "./advoAssistPostponeModalStyle";
import { useMutation } from "@tanstack/react-query";
import { updateResource } from "../../../services/ReactQuery/reactQueryService";
import { Appointment } from "../../../types/Appointment";
import { UseForm } from "../../../types/UseForm";
import { ProductUnion } from "../../../types/ProductUnion";
import dayjs from "dayjs";

type AdvoAssistPostponeModalProps = {
  legalbirdAppointment: Appointment;
  product: ProductUnion;
  submitAction: Function;
  open: boolean;
  handleClose: Function;
  refreshPage: Function;
};
export default function AdvoAssistPostponeModal({
  legalbirdAppointment,
  product,
  submitAction,
  open,
  handleClose,
  refreshPage,
}: AdvoAssistPostponeModalProps) {
  const [isLoading, setIsLoading] = useState(false);
  const updateMutation = useMutation({
    mutationFn: updateResource
  });
  const initialValues = {
    appointmentDate: null,
    appointmentTime: "",
  };
  const formDefinition: FormElementPropsWithoutProduct[] = [
    {
      type: "ValidatorDateField",
      path: "appointmentDate",
      translationPath: "courtAppointment.courtDate.appointmentDate",
      validators: [...dateFieldDefault, ...relatedFieldDefault("courtDate.appointmentTime")],
    },
    {
      type: "ValidatorTextField",
      path: "appointmentTime",
      translationPath: "courtAppointment.courtDate.appointmentTime",
      validators: relatedFieldDefault("courtDate.appointmentDate"),
      additionalProps: {
        type: "time",
        InputLabelProps: {
          shrink: true,
        },
      },
    },
  ];

  const onSubmit = async ({ values }: Record<string, any>) => {
    setIsLoading(true);
    await updateMutation.mutateAsync({
      uri: "appointments",
      id: legalbirdAppointment.id || 0,
      data: {
        appointmentDate: dayjs(formValue(values, "appointmentDate")).format("YYYY-MM-DD"),
        appointmentTime: formValue(values, "appointmentTime"),
      },
    });
    await submitAction("postpone", {});
    setIsLoading(false);
    refreshPage();
  };

  const useFormProps: UseForm = useForm({
    initialValues,
    onSubmit,
    // @ts-ignore
    identifier: legalbirdAppointment,
  });

  return (
    <LegalbirdIoModal
      handleClose={handleClose}
      open={open}
      title="Gerichtstermin verschieben"
      submitButton={
        <ButtonLoading
          disabled={!useFormProps.values.appointmentDate || !useFormProps.values.appointmentTime}
          onClick={useFormProps.handleSubmit}
          color="primary"
          variant={"contained"}
          isLoading={isLoading}
        >
          Termin verschieben
        </ButtonLoading>
      }
    >
      <p>Wenn der Gerichtstermin verschoben werden soll, bitte hier die neuen Daten eingeben:</p>
      <Grid container>
        {_.map(formDefinition, (formElementProps) => (
          <Grid
            sx={advoAssistPostponeModalStyle.spacingRight}
            key={formElementProps.path}
            size={{
              md: 6,
              xs: 12
            }}>
            <FormElement product={product} {...formElementProps} {...useFormProps} />
          </Grid>
        ))}
      </Grid>
      <p>
        <strong>Achtung</strong>: Der Klick auf “Termin verschieben” löst auch eine Terminverschiebung bei AdvoAssist
        aus.
      </p>
    </LegalbirdIoModal>
  );
}
